// Pre-Leads (site publico). Modulo isolado e aditivo.
// 1) Na chegada: guarda DE ONDE a pessoa veio (anuncio Google/Meta, Instagram, outro site...) por 90 dias, so neste navegador.
//    Nada pessoal: so os parametros do link (utm, gclid, fbclid) e o site de onde veio.
// 2) No toque em qualquer botao de WhatsApp com mensagem pronta: gera um codigo curto, coloca "(Ref. XXXXX)" na mensagem
//    e avisa o servidor (pre-lead). O WhatsApp abre exatamente como antes.
//    Pagina do imovel:  "Olá, gostaria de falar sobre o imóvel PROP86254 (Ref. G6VMP)."
//    Demais paginas:    "Olá, gostaria de mais informações. (Ref. G6VMP)"
// 3) Cada VISITA (sessao: ate 30 min sem atividade, ou chegada por um link de anuncio/campanha) ganha UM codigo e vira um
//    pre-lead com a origem. Se a pessoa toca no WhatsApp, o MESMO codigo vai na mensagem (a visita fica "chamou no WhatsApp").
// Nao age no painel (/admin) nem no aparelho logado no admin (seus testes nao viram pre-lead nem visita).

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const CHAVE = 'ica_origem';
const DIAS = 90;
const LETRAS = 'ACDEFGHJKMNPQRTUVWXY34679'; // sem letras/numeros parecidos (0/O, 1/I/L, 5/S, 8/B)
// Como o codigo entra na mensagem (troque aqui se quiser outro formato): {c} vira o codigo
export const FRASE_CODIGO = ' (Ref. {c})';

// Mensagem do imovel ("... imóvel PROP86254.") -> "... imóvel PROP86254 (Ref. XXXXX)."; as outras -> "... (Ref. XXXXX)" no fim
export function mensagemComCodigo(texto, codigo) {
  const ref = FRASE_CODIGO.replace('{c}', codigo);
  const m = String(texto || '').match(/^([\s\S]*\bim[oó]vel\s+[A-Za-z0-9-]{3,20})\.\s*$/i);
  if (m) return m[1] + ref + '.';
  return String(texto || '').replace(/\s+$/, '') + ref;
}

function ehAdmin() {
  try { return window.location.pathname.indexOf('/admin') === 0 || !!localStorage.getItem('token'); } catch (e) { return false; }
}

function ler() {
  try {
    const o = JSON.parse(localStorage.getItem(CHAVE) || 'null');
    if (o && o.ts && Date.now() - o.ts < DIAS * 86400000) return o;
  } catch (e) { /* ok */ }
  return null;
}

function gravar(o) {
  try { localStorage.setItem(CHAVE, JSON.stringify(o)); } catch (e) { /* ok */ }
}

export function capturarOrigem() {
  try {
    if (ehAdmin()) return;
    const p = new URLSearchParams(window.location.search);
    const campos = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
    const atual = {};
    campos.forEach((k) => { const v = p.get(k); if (v) atual[k] = v.slice(0, 200); });
    let ref = '';
    try { ref = document.referrer && new URL(document.referrer).hostname !== window.location.hostname ? document.referrer : ''; } catch (e) { ref = ''; }
    const salvo = ler();
    const temMarcacao = (o) => !!o && campos.some((k) => o[k]);
    const primeira = (salvo && salvo.primeira_visita) || new Date().toISOString();
    if (Object.keys(atual).length) {
      // chegou por um link marcado (anuncio/campanha): esta passa a ser a origem
      gravar({ ...atual, referrer: ref.slice(0, 300), entrada: (window.location.pathname || '').slice(0, 300), primeira_visita: primeira, ts: Date.now() });
    } else if (ref && (!salvo || !temMarcacao(salvo))) {
      // veio de outro site (Google organico, Instagram, portal...): vale mais que um acesso direto guardado antes,
      // mas nunca apaga um anuncio/campanha guardado (utm, gclid, fbclid continuam valendo)
      gravar({ referrer: ref.slice(0, 300), entrada: (window.location.pathname || '').slice(0, 300), primeira_visita: primeira, ts: Date.now() });
    } else if (!salvo) {
      gravar({ entrada: (window.location.pathname || '').slice(0, 300), primeira_visita: primeira, ts: Date.now() });
    }
  } catch (e) { /* nunca atrapalha o site */ }
}

function novoCodigo() {
  let c = '';
  try {
    const a = new Uint32Array(5);
    window.crypto.getRandomValues(a);
    for (let i = 0; i < 5; i += 1) c += LETRAS[a[i] % LETRAS.length];
  } catch (e) {
    for (let i = 0; i < 5; i += 1) c += LETRAS[Math.floor(Math.random() * LETRAS.length)];
  }
  return c;
}

function enviar(dados, caminho) {
  const corpo = JSON.stringify(dados);
  const url = BACKEND + (caminho || '/api/pre-leads');
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([corpo], { type: 'text/plain' }))) return;
  } catch (e) { /* tenta abaixo */ }
  try { fetch(url, { method: 'POST', body: corpo, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors' }).catch(() => {}); } catch (e) { /* ok */ }
}

function aoClicar(ev) {
  try {
    if (ehAdmin()) return;
    renovarVisita();
    const a = ev.target && ev.target.closest ? ev.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]') : null;
    if (!a) return;
    const u = new URL(a.getAttribute('href'), window.location.href);
    const texto = u.searchParams.get('text');
    if (!texto) return; // so botoes com mensagem pronta (o do rodape, sem mensagem, fica igual)
    if (/\((?:Ref|Cód)\. [A-Z0-9]{5}\)\.?\s*$/.test(texto)) return; // ja tem codigo (clique repetido)
    const codigo = codigoDaVisita();
    const original = a.getAttribute('href');
    u.searchParams.set('text', mensagemComCodigo(texto, codigo));
    a.setAttribute('href', u.toString());
    const m = texto.match(/im[oó]vel\s+([A-Za-z0-9-]{3,20})/i);
    const o = ler() || {};
    let disp = 'computador';
    try { disp = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'celular' : 'computador'; } catch (e) { /* ok */ }
    enviar({
      codigo,
      botao: a.getAttribute('data-testid') || '',
      pagina: (window.location.pathname || '').slice(0, 300),
      imovel_codigo: m ? m[1].toUpperCase() : '',
      utm_source: o.utm_source, utm_medium: o.utm_medium, utm_campaign: o.utm_campaign, utm_content: o.utm_content, utm_term: o.utm_term,
      gclid: o.gclid, gbraid: o.gbraid, wbraid: o.wbraid, fbclid: o.fbclid,
      referrer: o.referrer, entrada: o.entrada, primeira_visita: o.primeira_visita,
      dispositivo: disp,
    });
    // a mensagem do botao volta ao original logo depois (o proximo toque usa o mesmo codigo desta visita)
    setTimeout(() => { try { if (a.getAttribute('href') === u.toString()) a.setAttribute('href', original); } catch (e) { /* ok */ } }, 1500);
  } catch (e) { /* nunca atrapalha o clique */ }
}

const CHAVE_VISITA = 'ica_visita_ref';
const SESSAO_MS = 30 * 60 * 1000;

function lerVisita() {
  try {
    const v = JSON.parse(localStorage.getItem(CHAVE_VISITA) || 'null');
    if (v && /^[A-Z0-9]{5}$/.test(v.c || '') && Date.now() - (v.ts || 0) < SESSAO_MS) return v;
  } catch (e) { /* ok */ }
  return null;
}
function gravarVisita(c) {
  try { localStorage.setItem(CHAVE_VISITA, JSON.stringify({ c, ts: Date.now() })); } catch (e) { /* ok */ }
}
function renovarVisita() {
  const v = lerVisita();
  if (v) gravarVisita(v.c);
}
// Codigo da visita atual (o mesmo em todos os toques no WhatsApp desta visita); se a visita expirou, comeca outra
function codigoDaVisita() {
  const v = lerVisita();
  if (v) { gravarVisita(v.c); return v.c; }
  const c = novoCodigo();
  gravarVisita(c);
  return c;
}

function contarVisita(novo) {
  try {
    if (ehAdmin()) return;
    if (/bot|crawl|spider|slurp|headless|lighthouse|pagespeed|prerender/i.test(navigator.userAgent || '')) return;
    const marcado = /[?&](utm_[a-z]+|gclid|gbraid|wbraid|fbclid)=/i.test(window.location.search || '');
    const v = lerVisita();
    if (v && !marcado) { gravarVisita(v.c); return; } // mesma visita (ja registrada)
    const codigo = novoCodigo();
    gravarVisita(codigo);
    const o = ler() || {};
    let disp = 'computador';
    try { disp = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'celular' : 'computador'; } catch (e) { /* ok */ }
    enviar({
      codigo,
      utm_source: o.utm_source, utm_medium: o.utm_medium, utm_campaign: o.utm_campaign, utm_content: o.utm_content, utm_term: o.utm_term,
      gclid: o.gclid, gbraid: o.gbraid, wbraid: o.wbraid, fbclid: o.fbclid, referrer: o.referrer, primeira_visita: o.primeira_visita,
      entrada: (window.location.pathname || '').slice(0, 300), dispositivo: disp, novo: novo ? '1' : '',
    }, '/api/pre-leads/visita');
    paginaDaChegada = caminhoDaPagina(window.location); // a 1a pagina ja vai junto com a visita
  } catch (e) { /* nunca atrapalha o site */ }
}

let iniciado = false;
export function iniciarPreLeads() {
  if (iniciado) return;
  iniciado = true;
  let novo = false;
  try { novo = !ehAdmin() && !ler(); } catch (e) { novo = false; }
  capturarOrigem();
  contarVisita(novo);
  try { document.addEventListener('click', aoClicar, true); } catch (e) { /* ok */ }
}

// 4) Paginas visitadas: cada pagina aberta DENTRO da mesma visita vai para o pre-lead dela (so o caminho, nada pessoal).
//    So acrescenta numa visita que ja existe. Marcas de origem (utm, fbclid...) nao entram no caminho.
let paginaDaChegada = '';
let ultimaPagina = '';
function caminhoDaPagina(loc) {
  try {
    const q = new URLSearchParams(loc.search || '');
    Array.from(q.keys()).forEach((k) => { if (/^(utm_[a-z_]+|fbclid|gclid|gbraid|wbraid|igshid|ttclid|mc_eid)$/i.test(k)) q.delete(k); });
    const s = q.toString();
    return ((loc.pathname || '/') + (s ? '?' + s : '')).slice(0, 300);
  } catch (e) { return ''; }
}
export function registrarPagina(loc) {
  try {
    if (ehAdmin()) return;
    if (/bot|crawl|spider|slurp|headless|lighthouse|pagespeed|prerender/i.test(navigator.userAgent || '')) return;
    const p = caminhoDaPagina(loc);
    if (!p || p === ultimaPagina) return;
    ultimaPagina = p;
    if (paginaDaChegada) { const ch = paginaDaChegada; paginaDaChegada = ''; if (ch === p) return; }
    const v = lerVisita();
    if (!v) return;
    enviar({ codigo: v.c, pagina: p }, '/api/pre-leads/pagina');
  } catch (e) { /* nunca atrapalha o site */ }
}
